// index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './components/App';
import AccessGate from './components/AccessGate';
import './tailwind-output.css';

const queryClient = new QueryClient();
window.queryClient = queryClient;

// Register the push-only service worker (public/sw.js — no fetch/caching).
// Registration alone never prompts for notification permission; that happens
// only when the user opts in via the notifications modal.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('[PUSH] Service worker registration failed:', err);
    });
  });
}

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* Invitation gate (issue #80): anonymous visitors get the landing page
          on every route and <App/> never mounts, so none of its data queries
          fire for someone who has not been invited. */}
      <AccessGate>
        <App />
      </AccessGate>
    </QueryClientProvider>
  </React.StrictMode>
);
